import { FC } from "react";
import PropTypes from "prop-types";
import { Typography, Button, Grid, styled } from "@mui/material";

const GridContainer = styled(Grid)(
	({ theme }) => `
    margin-top: ${theme.spacing(3)};
`
);

interface PageTitleProps {
	heading?: string;
	subHeading?: string;
	docs?: string;
	buttons?: any;
	disabled?: boolean;
}

const PageTitle: FC<PageTitleProps> = ({
	heading = "",
	subHeading = "",
	docs = "",
	buttons = [],
	...rest
}) => {
	const is_toefl = localStorage.getItem("toeflData") ? JSON.parse(localStorage.getItem("toeflData")).is_toefl : 0;
	const toefl_setup = localStorage.getItem("toeflData") ? JSON.parse(localStorage.getItem("toeflData")).toefl_setup : [];
	const stage = parseInt(localStorage.getItem("Stage")) || 1;

	return (
		<GridContainer
			container
			justifyContent="space-between"
			alignItems="center"
			{...rest}>
			<Grid item xs={12} md={12}>
				<Typography variant="h5" component="h5" sx={{fontSize: {xs: "1.2rem", sm: "1.2rem", md: "1.3rem", lg: "1.5rem"}}} gutterBottom>
					{heading}
					{(is_toefl === 1 && heading) &&
						toefl_setup.length > 0 &&
						toefl_setup[stage - 1]?.name &&
						/^\/classes\/tryout\/\d+(\/)?(\?.*)?$/.test(window.location.pathname)
							? ` - ${toefl_setup[stage - 1]?.name}`
							: ""}
				</Typography>
				<Typography variant="subtitle2">{subHeading}</Typography>
			</Grid>
			<Grid item>
				{buttons &&
					buttons.map((item, index) => {
						return (
							<Button
								key={index}
								sx={{ mt: { xs: 2, md: 0 }, ml: { md: 2 }, mr: { xs: 1, md: 0 } }}
								variant={item.isContained ? "contained" : "outlined"}
								disabled={item.disabled}
								onClick={item.onclick}
								color={item.color || "primary"}
							>
								{item.title}
							</Button>
						);
					})}
			</Grid>
		</GridContainer>
	);
};

PageTitle.propTypes = {
	heading: PropTypes.string,
	subHeading: PropTypes.string,
	docs: PropTypes.string,
};

export default PageTitle;
